import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '@card-software/nexus-utilities';
import { Department } from '../../models/department/deparment';

@Injectable({
  providedIn: 'root',
})
export class DepartmentProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.userMasterApi + '/api/v1/department';

  getAll(): Observable<ApiResponse<Department[]>> {
    return this.httpClient.get<ApiResponse<Department[]>>(`${this.baseUrl}/all`);
  }
}
